import React, { useContext } from "react";
import { State } from "../context/State";

function Descriptor() {
  const { description } = useContext(State);
  return (
    <div
      style={{
        height: "1rem",
        lineHeight: "1rem",

        borderTopLeftRadius: "3px",
        borderTopRightRadius: "3px",
        padding: "0.5rem 1.5rem",
        backgroundColor: "#d1d1d1"
      }}
    >
      {description}
    </div>
  );
}

export default Descriptor;
